import { jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
import { COLORS } from '@constants/colors';
import { Box, Collapse, Paper, Typography, useTheme } from '@mui/material';
import { useState } from 'react';
export const CollapsibleSection = ({ number, title, children, disabled = false, open: controlledOpen, onToggle, defaultOpen = false, elevation = 0, sx = {}, }) => {
    const theme = useTheme();
    const [internalOpen, setInternalOpen] = useState(defaultOpen);
    // Determine if controlled or uncontrolled
    const isControlled = controlledOpen !== undefined;
    const isOpen = isControlled ? controlledOpen : internalOpen;
    const handleToggle = () => {
        if (disabled)
            return;
        const newOpenState = !isOpen;
        if (!isControlled) {
            setInternalOpen(newOpenState);
        }
        onToggle?.(newOpenState);
    };
    return (_jsxs(Paper, { elevation: elevation, sx: {
            borderRadius: 1,
            border: `1px solid ${theme.palette.divider}`,
            overflow: 'hidden',
            transition: 'all 0.2s ease-in-out',
            opacity: disabled ? 0.6 : 1,
            pointerEvents: disabled ? 'none' : 'auto',
            boxShadow: COLORS.shadow.infoBox,
            ...sx,
        }, children: [_jsx(Box, { onClick: handleToggle, sx: theme => ({
                    borderBottom: `1px solid ${theme.palette.divider}`,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    px: theme.spacing(3),
                    py: theme.spacing(2),
                    cursor: disabled ? 'not-allowed' : 'pointer',
                    backgroundColor: theme.palette.background.paper,
                    '&:hover': disabled
                        ? {}
                        : {
                            backgroundColor: theme.palette.action.hover,
                        },
                    transition: 'background-color 0.2s ease-in-out',
                }), children: _jsxs(Typography, { variant: "subtitle1", sx: {
                        fontWeight: 700,
                        color: theme.palette.primary.main,
                        filter: disabled ? 'blur(0.5px)' : 'none',
                    }, children: [number, ". ", title] }) }), _jsx(Collapse, { in: isOpen, timeout: "auto", unmountOnExit: true, children: _jsx(Box, { sx: {
                        p: 3,
                        pt: 2,
                        backgroundColor: theme.palette.background.default,
                        filter: disabled ? 'blur(0.5px)' : 'none',
                        transition: 'filter 0.2s ease-in-out',
                    }, children: children }) })] }));
};
